import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TopUpContact } from '../../../../types/types';

const initialState:TopUpContact = {
    phone_number:"",
    contact_name:""
};

const topUpContact = createSlice({
  name: 'topUpContact',
  initialState,
  reducers: {
    setTopUpContact(state,action:PayloadAction<TopUpContact>){
        return (state = action.payload)
    }
  },

});

// Reducer
export default topUpContact.reducer;

// Actions
export const {setTopUpContact} = topUpContact.actions;

